import styled, { css } from 'styled-components';

type OverlayProps = {
  visible: boolean;
  isFull?: boolean;
};

export const Container = styled.div<OverlayProps>`
  ${({ visible }) => css`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: flex-end;
    height: var(--height-full);
    background: transparent;
    z-index: 25;
    opacity: ${visible ? 1 : 0};
    pointer-events: ${visible ? 'all' : 'none'};
    transition: opacity 250ms ease-in-out;
  `}
`;

export const Overlay = styled.div<OverlayProps>`
  ${({ visible, isFull }) => css`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: flex-end;
    width: 100%;
    height: 100%;
    background: #00000066;
    z-index: 50;

    @media (min-width: 900px) {
      border-top-left-radius: 0;
      border-top-right-radius: 0;

      background: ${isFull ? 'transparent' : '#00000066'};
    }
  `}
`;

const SidebarModifier = {
  isFull: () => css`
    box-shadow: -8px 0px 24px #00000029;

    @media (min-width: 900px) {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  `
};

export const Modal = styled.div<OverlayProps>`
  ${({ visible, isFull }) => css`
    background: #fff;
    border-top-left-radius: 40px;
    border-top-right-radius: 40px;
    padding: 32px;
    transition: transform 250ms ease-in-out;
    z-index: 100;
    max-height: var(--height-full);
    overflow: auto;
    width: 100%;
    transform: ${visible ? 'translateY(0)' : 'translateY(100%)'};
    text-align: center;
    ${isFull && SidebarModifier.isFull()}
  `}
`;

export const CloseWrapper = styled.div`
  margin-top: 16px;
`;
